/**
 * Tenants that have access to beta features
 */
export const BETA_TENANTS = ['resultcode', 'rtiot', 'txdemo'];

/**
 * Tenants that should only see transactions (hide events)
 */
export const TRANSACTIONS_ONLY = ['txdemo'];

/**
 * Check if a tenant has access to beta features
 */
export const isBetaTenant = (tenantId: string | null): boolean => {
  if (!tenantId) return false;
  return BETA_TENANTS.includes(tenantId.toLowerCase());
};

/**
 * Check if a tenant is a transactions-only tenant
 */
export const isTransactionsOnlyTenant = (tenantId: string | null): boolean => {
  if (!tenantId) return false;
  return TRANSACTIONS_ONLY.map((id) => id.toLowerCase()).includes(tenantId.toLowerCase());
};
